import React from 'react';
import propTypes from 'prop-types';
import {
  FAILURE,
  PENDING
} from '../../utils/status';
import {LoadingScreen} from '../Loading';
import PlaceholderImage from '../PlaceholderImage';
import * as navigator from '../../native/navigator';
import './style.css';


InitScreen.propTypes = {
  status: propTypes.string.isRequired,
  loadImage: propTypes.string,
};

InitScreen.defaultProps = {
  status: PENDING
};

export default function InitScreen(props) {
  let {status, loadImage, component, ...rest} = props;
  let Component = component;

  if (status === PENDING) {
    if(loadImage){
      return (<PlaceholderImage loadImage={loadImage} />);
    }else{
      return (<LoadingScreen />);
    }
    
  } else if (status === FAILURE) {
    return (
      <div id='init-screen'>
        <span>页面加载失败</span>
        <br />
        <button onClick={() => {
          navigator.back();
        }}>返回</button>
        <button onClick={() => {
          navigator.reload();
        }}>刷新</button>
      </div>
    );
  } else {
    return <Component {...rest} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/InitScreen/index.js